import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { GeneralInnovationActivityResultsService } from '../../../../../services/general-innovation-activity-results.service';
import { IStageTopFirm } from '../../../../../../../core/models/results.model';
import { getStageColor } from '../../../../../../../shared/utils/bracket.utils';

export interface StageFirmsDialogData {
  stage: number;
  stage_name: string;
  tabId: string;
}

@Component({
  selector: 'app-stage-firms-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './stage-firms-dialog.component.html',
  styleUrl: './stage-firms-dialog.component.css',
})
export class StageFirmsDialogComponent {
  firms: IStageTopFirm[] = [];
  loading = true;
  error = false;

  getStageColor = getStageColor;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: StageFirmsDialogData,
    private dialogRef: MatDialogRef<StageFirmsDialogComponent>,
    private apiService: GeneralInnovationActivityResultsService,
  ) {
    this.loadFirms();
  }

  private loadFirms(): void {
    this.apiService.getStageTopFirms(this.data.stage, this.data.tabId).subscribe({
      next: (res) => {
        this.firms = res.body?.payload?.data ?? [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.error = true;
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
